import { AntPopover, Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { Company } from 'modules/domain/company/types'
import { Contact } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { Card } from 'views/components/Card/Card'
import { Hr } from 'views/components/Hr/Hr'
import APhone from 'views/ui/Phone/APhone'

interface Props {
  company: Company
  phone: string
}

const ContactEntry = ({ contact, formatDate }: { contact: Contact; formatDate: (string, any) => string }) => {
  const { t } = useTranslation('company')
  return (
    <div>
      <div>
        <div>{contact.fullname}</div>
        {contact.position && (
          <Text color="secondary" typography="bodyMedium">
            {contact.position}
          </Text>
        )}
        <Text color="secondary" typography="bodyMedium">
          {t('lastCall')}: {formatDate(contact.last_call, { withTime: true })}
        </Text>
      </div>
      <APhone phone={contact.phone} />
    </div>
  )
}

const PopoverWrapper = styled.div`
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const PopoverContent = ({
  contacts,
  formatDate,
  phone,
}: {
  contacts: Contact[]
  formatDate: (date: string, options?: any) => string
  phone: string
}) => {
  const { t } = useTranslation('company')
  return (
    <Card.Container>
      <PopoverWrapper>
        <div style={{ display: 'flex', gap: '8px' }}>
          {t('userPhone')}: <APhone phone={phone} />
        </div>
        <Hr />
        {contacts.map((c, index) => (
          <ContactEntry key={index} contact={c} formatDate={formatDate} />
        ))}
      </PopoverWrapper>
    </Card.Container>
  )
}

export const CompanyGroupedContacts = ({ company, phone }: Props) => {
  const { t } = useTranslation('company')
  const parentId = company.parent?.id || company.id
  const [, contacts] = useSingleEntity<Contact[]>(endpoints.companyGroupContacts(parentId))
  const [popoverVisible, setPopoverVisible] = useState(false)
  const formatDate = useFormatDate()
  if (!contacts) return null
  return (
    <AntPopover
      content={<PopoverContent contacts={contacts} formatDate={formatDate} phone={phone} />}
      placement="bottom"
      trigger="click"
      open={popoverVisible}
      onOpenChange={() => setPopoverVisible(!popoverVisible)}
    >
      <AButton id="bitActions" color="secondary" size="small" onClick={(e) => e.stopPropagation()}>
        {t('showContacts')}
      </AButton>
    </AntPopover>
  )
}
